/** @file Language choices for the Settings dropdown, generated from the catalogs (English first). */
import type { Catalog, PartialCatalog } from './types';

/** `code` is the catalog key stored in `settings.ui.lang`; `name` is the language's own name (`settings.languageName`). */
export function catalogLanguages(catalogs: { en: Catalog } & Record<string, PartialCatalog>): { code: string; name: string }[] {
  const others = Object.keys(catalogs).filter((code) => code !== 'en').sort();
  return ['en', ...others].map((code) => ({ code, name: catalogs[code]?.settings?.languageName ?? code }));
}
